import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import useManagedField from '../queries/useManagedField';
import MenuOption from './MenuOption';
import Feedback from '../../Feedback';
import ToggleButton from '../../Dropdown/ToggleButton';
import Menu from '../../Dropdown/Menu';
import { getStyles as getDropdownStyles } from '../../Dropdown/Dropdown';
const getStyles = createUseStyles({
    legend: {
        width: '100%',
    },
});
const Select = ({ className, labelText, defaultValue, onChange, isError = false, options = [], disabled = false, }) => {
    const [value, setValue] = useState(defaultValue);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const onInputClick = (event) => {
        setValue(event.currentTarget.value);
        setIsMenuOpen(false);
        onChange(event);
    };
    const getLabel = optionValue => options.find(option => option?.value === optionValue)?.label;
    const dropdownStyles = getDropdownStyles();
    const styles = getStyles();
    return (React.createElement("fieldset", { className: classNames(dropdownStyles.root, className) },
        React.createElement("legend", { className: styles.legend },
            React.createElement(ToggleButton, { onClick: () => setIsMenuOpen(!isMenuOpen), onBlur: () => setIsMenuOpen(false), isOpen: isMenuOpen, value: getLabel(value), isError: isError, disabled: disabled || options.length === 0 }, labelText)),
        React.createElement(Menu, { isOpen: isMenuOpen }, options.map(data => (React.createElement(MenuOption, { key: data.value, value: data.value, checked: data.value === defaultValue, onClick: onInputClick }, data.label))))));
};
const ManagedSelect = (props) => {
    const { defaultValue } = props;
    const { meta: { error, isTouched, isValidating }, inputProps, setValue, } = useManagedField(props);
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);
    const isError = !isValidating && isTouched && error;
    return (React.createElement(React.Fragment, null,
        isError && React.createElement(Feedback, { type: "error" }, error),
        React.createElement(Select, { ...inputProps, defaultValue: defaultValue, isError: isError })));
};
Select.Managed = ManagedSelect;
export default Select;
//# sourceMappingURL=Select.js.map